export const STEP_DRAFT = 1;
export const STEP_TRANSMITTED = 2;
export const STEP_PREPARATION = 3;
export const STEP_VALIDATION = 4;
export const STEP_DONE = 5;
